import React from 'react';
import Steps from './Steps';
import logoMobile from "../../../assets/logoa2.png";
import { useContext } from 'react';
import { userContext } from '../../../context/usercontext';
import Header from '../menu/Header';
import Menu from '../menu/Menu';
import { sendPayRequest } from '../../../services/kojaServices';
import { serverApi } from '../../../confing/confing';
import Swal from 'sweetalert2'
import { toast } from "react-hot-toast";

const Factor = () => {

   const {setRequestStep,factorInfo,estateInfo,expertInfo} = useContext(userContext)
    const nextStep = async(values)=>{
        try{
          Swal.fire({
            title: 'لطفا منتظر بمانید',
            didOpen: () => { Swal.showLoading() },
          })       
           const {data} = await sendPayRequest(factorInfo.token)
          console.log(data)
          window.location.href = `${serverApi}pay/${factorInfo.token}`;
          Swal.close()
          Swal.fire({
            icon: 'success',
            title: `درخواست شما با موفقیت ثبت شد`,
            showConfirmButton: false,
            timer: 2000
          })
        }catch(err){
          console.log(err)
          Swal.close()
          toast.error("خطایی رخ داده است مجدد تلاش کنید")
        }
    }
    const previousStep = (values)=>{
        setRequestStep(3)
    }
    return (
        <div className='expertRequest2'>
        <Header/>
        <div className='d-flex request-box-content' style={{margin:"20px 30px 0px 30px"}}>
        <Menu/>
        <div className='w-100 m-1'>
        <Steps step={4}/>
        <div className='factor-table-box'>
        <div className='factor-table-header'>
        <div className='text-end'>
        <p className='mb-0'>صورت حساب: </p>
        <p className='mb-0'>شماره فاکتور: </p>
        <p className='mb-0'>تاریخ: </p>
        </div>
        <h5 className='d-none d-md-block'>فاکتور فروش</h5>
        <img alt="" src={logoMobile} className="user-menu-logo" style={{width:"60px",height:"60px",borderRadius:"30px"}} />
        </div>
        <div className='factor-table-body'>
        <div className='d-flex mb-2 ps-2 pe-2' style={{borderBottom:"5px solid #9CB8C2"}}>
        <p className='factor-table-item'>شماره درخواست: {factorInfo.token} </p>
        </div>
        <div className='d-flex mb-2 ps-2 pe-2' style={{borderBottom:"5px solid #9CB8C2"}}>
        <p className='factor-table-item'>آدرس: {estateInfo.address} </p>
        </div>
        <div className='d-flex mb-2 ps-2 pe-2' style={{borderBottom:"5px solid #9CB8C2"}}>
        <p className='factor-table-item'>تعداد کارشناس انتخابی : {expertInfo.arry.length}</p>
        </div>
        <div className='d-flex mb-2 ps-2 pe-2'>
        <p className='factor-table-item'>مبلغ پرداخت بابت بیعانه: {factorInfo.price.toLocaleString()} تومان </p>
        </div>
        </div>
        </div>
        <div className='d-flex justify-content-between mx-3'>
        <div className=' request-next-btn-box'>
        <button  type='submit' className='btn request-next-btn' onClick={()=>{nextStep()}}>بعدی</button>
        </div>
        <div className=' request-Previous-btn-box '>
        <button className='btn request-Previous-btn' type='button' onClick={()=>{previousStep()}}>قبلی</button>
        </div>
        </div>
            
        </div>
        </div>
        </div>
        
    );
};

export default Factor;